import { createReducer } from 'utils/redux'

import { CampaignsState } from './types'

const DEFAULT_ACTIVE_CAMPAIGN_STATE = {
  id: null,
  attributes: {},
  message: null
}

const defaultState: CampaignsState = {
  activeCampaign: DEFAULT_ACTIVE_CAMPAIGN_STATE,
  campaignEvalId: null,
  enrolledCampaignIds: [],
  enrolledInteractionIds: [],
  ineligibleCampaignIds: [],
  unreadCampaigns: [],
  campaignConversations: []
}

const receiveActiveCampaignHandler = ({ action, draft }) => {
  draft.activeCampaign = action.payload.data
}

const receiveCampaignEvalIdHandler = ({ action, draft }) => {
  draft.campaignEvalId = action.payload.campaignEvalId
}

const clearActiveCampaignHandler = ({ draft }) => {
  draft.activeCampaign = DEFAULT_ACTIVE_CAMPAIGN_STATE
}

const receiveIneligibleCampaignsHandler = ({ action, draft }) => {
  draft.ineligibleCampaignIds = action.payload
}

const receiveUnreadCampaignsHandler = ({ action, draft }) => {
  draft.unreadCampaigns = action.payload
}

const receiveEnrolledCampaignHandler = ({ action, draft }) => {
  draft.enrolledCampaignIds = [...draft.enrolledCampaignIds, action.payload]
}

const receiveEnrolledInteractionHandler = ({ action, draft }) => {
  draft.enrolledInteractionIds = [...draft.enrolledInteractionIds, action.payload]
}

const actions = {
  RECEIVE_ACTIVE_CAMPAIGN: receiveActiveCampaignHandler,
  CLEAR_ACTIVE_CAMPAIGN: clearActiveCampaignHandler,
  RECEIVE_CAMPAIGN_EVAL_ID: receiveCampaignEvalIdHandler,
  RECEIVE_UNREAD_CAMPAIGNS: receiveUnreadCampaignsHandler,
  RECEIVE_ENROLLED_CAMPAIGN: receiveEnrolledCampaignHandler,
  RECEIVE_ENROLLED_INTERACTION: receiveEnrolledInteractionHandler,
  RECEIVE_INELIGIBLE_CAMPAIGNS: receiveIneligibleCampaignsHandler
}

const campaignReducer = createReducer(
  defaultState,
  actions
)

export default campaignReducer
